export default __webpack_public_path__ + "static/about-us-3-8e285291821066c97cf3a76dfcbff03e.png";